export const CAPTCHA_ABANDONED_MESSAGE = 'captcha error';
const TEST_QUERY_PARAMS = [
    'viewerPlatformOverrides',
    'thunderboltTag',
    'editor-elements-override',
    'boltTag'
];
const TEST_BASE_URLS = [
    'https://platform-integration',
    'https://qatestformsuser',
    'https://form-sled.wixstudio.com',
    'https://form-sled.wixsite.com'
];
const isTestRun = ({ baseUrl, query, isPreview })=>isPreview || TEST_QUERY_PARAMS.some((param)=>!!query[param]) || TEST_BASE_URLS.some((testBaseUrl)=>baseUrl.startsWith(testBaseUrl));
export const shouldOpenCaptchaChallenge = (context)=>context.isBot && (!!context.query.forceChallenge || !isTestRun(context));

//# sourceMappingURL=captcha-challenge.js.map